import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

import { LayoutComponent } from './layouts/layout.component';
import { LayoutUserComponent } from './layouts/layout-user.component';

const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },

    { path: 'auth', loadChildren: () => import('./feature/auth/auth.module').then(m => m.AuthModule) },
    { path: 'panel', component: LayoutUserComponent, loadChildren: () => import('./feature-user/feature-user.module').then(m => m.FeatureUserModule), canActivate: [AuthGuard] },
    { path: 'admin', component: LayoutComponent, loadChildren: () => import('./feature/feature.module').then(m => m.FeatureModule), canActivate: [AuthGuard] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
    exports: [RouterModule]
})

export class AppRoutingModule { }
